import React from "react";
import "../styles/Map.css";

const Map = () => {
  return (
    <section className="map-section">

      <div className="map-heading">

        <span>OUR LOCATION</span>

        <h2>Visit Our Office</h2>

        <p>
          We'd love to meet you. Visit our office or contact us for a free
          demonstration of our fuel station automation solutions.
        </p>

      </div>

      <div className="map-container">

        <iframe
          title="ITWORLD Location"
          src="https://www.google.com/maps?q=Lahore,Pakistan&output=embed"
          loading="lazy"
          allowFullScreen
        ></iframe>

      </div>

    </section>
  );
};

export default Map;